"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconType = void 0;
var IconType;
(function (IconType) {
    IconType["SVG"] = "SVG";
    IconType["ICON_FONT"] = "FA";
    IconType["SRC"] = "SRC";
})(IconType = exports.IconType || (exports.IconType = {}));
